import { UserIcon, UsersIcon } from 'lucide-react';
import { useSaleScope } from '@/hooks/sale/use-sale-scope';
import { SaleScope } from '@/types/sale';
import { cn } from '@/utils/shared/Utils';

const OPTIONS = [
  { value: SaleScope.Group, label: 'Hela gruppen', Icon: UsersIcon },
  { value: SaleScope.Participation, label: 'Bara jag', Icon: UserIcon },
];

/** Switches the overview between the whole group's sale and what the signed-in seller has sold. */
export default function SaleScopeTab() {
  const { setScope, scope } = useSaleScope();
  const current = scope === SaleScope.Participation ? SaleScope.Participation : SaleScope.Group;

  return (
    <div
      role="tablist"
      aria-label="Visa försäljning för"
      className="mb-4 grid grid-cols-2 gap-1 rounded-xl bg-gray-200/70 p-1 sm:inline-grid dark:bg-gray-900/60"
    >
      {OPTIONS.map(({ value, label, Icon }) => {
        const selected = value === current;

        return (
          <button
            key={value}
            type="button"
            role="tab"
            aria-selected={selected}
            onClick={() => setScope(value)}
            className={cn(
              'flex items-center justify-center gap-2 rounded-lg px-4 py-2 text-sm transition-colors',
              selected
                ? 'bg-white font-semibold text-gray-900 shadow-sm dark:bg-gray-800 dark:text-gray-100'
                : 'text-gray-500 hover:text-gray-800 dark:text-gray-400 dark:hover:text-gray-100',
            )}
          >
            <Icon size={16} aria-hidden="true" />
            {label}
          </button>
        );
      })}
    </div>
  );
}
